import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { getConfigValue } from '@jutro/config';
import { warning } from '@jutro/logger';
import { AuthContextProvider } from './AuthContextProvider';
import { AuthStateProvider } from './AuthStateProvider';
import { LoginCallback } from './LoginCallback';
export const OPENID_SCOPE = 'openid';
export const DEFAULT_EXPIRE_EARLY_SECONDS = 30;
export const AUTO_RENEW = true;
export const DEFAULT_STORAGE = 'localStorage';
const getTokenManagerConfig = () => {
  const expireEarlySeconds = getConfigValue('JUTRO_AUTH_EXPIRE_EARLY_SECONDS', DEFAULT_EXPIRE_EARLY_SECONDS);
  const autoRenew = getConfigValue('JUTRO_AUTH_AUTO_RENEW', AUTO_RENEW);
  const storage = getConfigValue('JUTRO_AUTH_STORAGE', DEFAULT_STORAGE);
  if (storage === 'cookie') {
    warning(`cookie storage option is not recommended as it's not secure`);
  }
  return {
    expireEarlySeconds,
    storage,
    autoRenew
  };
};
const getAuthConfig = () => {
  return {
    isEnabled: getConfigValue('JUTRO_AUTH_ENABLED', false),
    issuer: getConfigValue('JUTRO_AUTH_ISSUER', ''),
    clientId: getConfigValue('JUTRO_AUTH_CLIENT_ID', ''),
    redirectBase: getConfigValue('JUTRO_AUTH_REDIRECT_BASE', window.location.origin),
    redirectPath: getConfigValue('JUTRO_AUTH_REDIRECT_PATH', ''),
    scope: getConfigValue('JUTRO_AUTH_SCOPE', `${OPENID_SCOPE},profile,email`),
    pkce: getConfigValue('JUTRO_AUTH_PKCE_ENABLED', false),
    tokenManager: getTokenManagerConfig()
  };
};
export const AuthProvider = ({
  children,
  onAuthSessionExpired
}) => {
  const authConfig = getAuthConfig();
  if (authConfig.isEnabled) {
    const issuer = authConfig.issuer,
      clientId = authConfig.clientId,
      redirectBase = authConfig.redirectBase,
      redirectPath = authConfig.redirectPath,
      scope = authConfig.scope,
      pkce = authConfig.pkce,
      tokenManager = authConfig.tokenManager;
    const redirectUri = `${redirectBase}${redirectPath}`;
    const scopes = scope.split(',');
    if (_indexOfInstanceProperty(scopes).call(scopes, OPENID_SCOPE) === -1) {
      scopes.push(OPENID_SCOPE);
    }
    return React.createElement(AuthStateProvider, {
      issuer: issuer,
      client_id: clientId,
      redirect_uri: redirectUri,
      scope: scopes,
      pkce: pkce,
      tokenManager: tokenManager,
      onSessionExpired: onAuthSessionExpired
    }, React.createElement(Switch, null, React.createElement(Route, {
      path: redirectPath,
      component: LoginCallback
    }), React.createElement(AuthContextProvider, null, children)));
  }
  return children;
};
AuthProvider.__docgenInfo = {
  componentName: "AuthProvider",
  packageName: "@jutro/auth",
  description: "A HOC that wraps children components in Okta Security. This will initialize the\nokta configuration and set up a callback route to handle the login redirect.\nWrapping will only happen if authentication is enabled, otherwise the original\ncomponent will be returned, unwrapped.",
  displayName: "AuthProvider",
  methods: [],
  actualName: "AuthProvider"
};